import React from 'react';
import { array, bool, func, number, object, oneOfType, string } from 'prop-types';
import CompensationSummaryCard from '../CompensationSummaryCard/CompensationSummaryCard';
import ParticipationMatchesGrid from '../../MarketPricing/ParticipationMatches/ParticipationMatchesGrid/ParticipationMatchesGrid';

CompensationSummaryParticipationMatchDetails.propTypes = {
  actions: object,
  benchmarkYear: number,
  counts: object,
  showParticipationMatchesWithData: bool,
  showParticipationMatchesWithoutData: bool,
  currency: string,
  displayIn: string,
  filterText: string,
  grid: object,
  groupId: string,
  hasData: bool,
  hideSelect: bool,
  isConfigVisible: bool,
  isPrint: bool,
  jobId: oneOfType([number, string]),
  masterAccountId: string,
  monetaryRounding: number,
  numericRounding: number,
  percentRounding: number,
  saveConfigSettings: func,
  selectedSurveys: array,
  selectedViewPk: number,
  setTotalFilteredCount: func,
  setTotalFilteredDataCount: func,
  setTotalFilteredNoDataCount: func,
  showWithData: bool,
  surveyJobs: object,
  surveyViewName: string
};

function CompensationSummaryParticipationMatchDetails(props) {
  const {
    showParticipationMatchesWithData,
    showParticipationMatchesWithoutData,
    onToggle,
    saveConfigSettings,
    counts,
    isConfigVisible
  } = props;
  const isPrint = true;

  function getCard(title, showData, isChecked) {
    return (
      <CompensationSummaryCard
        cardTitle={title}
        checked={isChecked}
        hasData={true}
        onToggle={onToggle}
        isConfigVisible={isConfigVisible}
        saveConfigSettings={saveConfigSettings}
      >
        <ParticipationMatchesGrid
          actions={props.actions}
          benchmarkYear={props.benchmarkYear}
          counts={counts}
          currency={props.currency}
          displayIn={props.displayIn}
          filterText={''}
          grid={props.grid}
          groupId={props.groupId}
          hideSelect={props.hideSelect}
          isPrint={isPrint}
          jobId={props.jobId}
          loadingId={null}
          masterAccountId={props.masterAccountId}
          monetaryRounding={props.monetaryRounding}
          numericRounding={props.numericRounding}
          percentRounding={props.percentRounding}
          selectedSurveys={props.selectedSurveys}
          selectedViewPk={props.selectedViewPk}
          setTotalFilteredCount={() => {}}
          setTotalFilteredDataCount={() => {}}
          setTotalFilteredNoDataCount={() => {}}
          showWithData={showData}
          stickyHeader={false}
          surveyJobs={props.surveyJobs}
          surveyViewName={props.surveyViewName}
        />
      </CompensationSummaryCard>
    );
  }

  return (
    <>
      {getCard('Participation Matches With Data', true, showParticipationMatchesWithData)}
      {getCard('Participation Matches Without Data', false, showParticipationMatchesWithoutData)}
    </>
  );
}

export default CompensationSummaryParticipationMatchDetails;
